import { setWindowLocation } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import { getLookupMethodsConfig } from '../beta/lookupMethodsConfig';
import { getSocialConfigErrors } from '../beta/socialErrorsConfig';

export const getSignupConfiguration = ({
    request,
    gaSettings,
    captcha,
    socialSSOSettings,
    skipSocialCalls,
    socialDataMock,
    fp,
    referrer,
    featureFlags,

    dispatchUpdateFormType,
    redirectToLogInAction,
}: any) => {
    const _request = { ...request };

    return {
        header: {
            titleText: 'Create an account',
            headerLinkProps: {
                onHeaderClick: redirectToLogInAction,
                linkTo: '/signin/',
                linkText: gettext('Log in'),
                linkTestid: 'go-to-login',
            },
        },
        lookupMethods: getLookupMethodsConfig(),
        signupMethods: {
            success: (response: any) => {
                if (response?.redirectUrl) {
                    setWindowLocation(response.redirectUrl);
                }
            },
            error: {
                DEFAULT_ERROR: () => ({}),
                HAS_PASSWORD: {
                    getNotification: () => ({
                        ctaMessage: gettext('Log in'),
                        ctaAction: redirectToLogInAction,
                    }),
                },
            },
        },
        socialMethods: {
            success: (response: any) => {
                if (response?.redirectUrl) {
                    setWindowLocation(response.redirectUrl);
                }
            },

            error: getSocialConfigErrors({ dispatchUpdateFormType }),
        },
        forgotPasswordMethods: {},
        analytics: {
            request: _request,
            gaSettings,
        },
        captcha,
        request: _request,
        social: {
            SSOSettings: socialSSOSettings,
            skipSocialCalls,
            socialDataMock,
            secondarySocialMethods: {
                facebook: true,
                apple: true,
            },
        },
        featureFlags,
        fp,
        referrer,
    };
};
